import { ActionSource } from 'owa-mail-store';

export default {
    undo: {
        name: 'TnS_Undo',
        customData: (actionSource: ActionSource) => [actionSource],
    },
};
